import React, { Suspense } from 'react';

const PublicRoute = ({ component: Component, ...rest }) => (
  <Suspense fallback={<div>Loading...</div>}>
    <Component {...rest} />
  </Suspense>
);
export default PublicRoute;
